import * as React from 'react';
import { useEffect } from 'react';
import { useAccaTestResultStore } from '@stores/AccaTestResultStore';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import TestSummary from './testSummary';
import SrGuide from './srGuide';
import V4Guide from './v4Guide';
import GameGuide from './gameGuide';
import TestTip from './testTip';
import CopyrightWarning from './copyrightWarning';

const ApplyResultContent = () => {
  const { accaResultStore } = useResultStore();
  const accResultSn = useAccaTestResultStore((state) => state.accResultSn);
  const { fetchAccApplyResult, fetchAccApplySelfReport, fetchAccApplyVideo, fetchAccApplyGame, fetchAccApplyTip } =
    accaResultStore;

  useEffect(() => {
    initAccApply();
  }, [accResultSn]);

  const initAccApply = () => {
    if (accResultSn === null) return;
    // @ts-ignore
    accaResultStore.fetchAccStatusUser?.();
    fetchAccApplyResult();
    fetchAccApplySelfReport();
    fetchAccApplyVideo();
    fetchAccApplyGame();
    fetchAccApplyTip();
  };

  return (
    <>
      {/* [D] 응시 결과 요약 영역 */}
      <TestSummary />

      {/* [D] 성향 파악 응시 결과 영역 */}
      <SrGuide />

      {/* [D] 영상 면접 응시 결과 영역 */}
      <V4Guide />

      {/* [D] 전략 게임 응시 결과 영역 */}
      <GameGuide />

      {/* [D] 맟춤형 꿀팁 영역 */}
      <TestTip />

      {/* [D] 경고 영역 */}
      <CopyrightWarning />
    </>
  );
};

export default ApplyResultContent;
